module.exports = __webpack_public_path__ + "static/img/22.201a49d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/22.jpg
// module id = EJz9
// module chunks = 16